var map = {
	"./music-instructions.json": 4554,
	"./music-library-intro2024.json": 4555,
	"./music-library-launch2024.json": 4556,
	"./music-progression.json": 4557,
	"./startSourcesAdvanced.json": 4558,
	"./startSourcesSimple.json": 4559,
	"./startSourcesSimple2.json": 4560,
	"./startSourcesTracks.json": 4561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4332;